import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UrlHelperService } from '../../util/url-helper.service';
import { Assortment } from './assortment.model';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AssortmentsService {
  private http = inject(HttpClient);
  private urlHelper = inject(UrlHelperService);

  private readonly assortments$: Observable<Assortment[]>;

  constructor() {
    this.assortments$ = this.http
      .get<Assortment[]>(this.urlHelper.prepareApiPath('assortments'))
      .pipe(shareReplay(1));
  }

  getAssortments(): Observable<Assortment[]> {
    return this.assortments$;
  }
}
